'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');


/*****************
 ** WEBPACK FOOTER
 ** ./~/chem-equilibrium/~/ml-matrix/src/index.js
 ** module id = 2
 ** module chunks = 0
 **/